// var shortCutImg = 'https://statich5clover.happyelements.com/clover-web.png';
// var shareImg = 'https://statich5clover.happyelements.com/clover-web-200.png';
var shortCutImg = 'https://statich5clover.happyelements.com/resource/share/bg/bg_1.jpg';
var shareImg = 'https://statich5clover.happyelements.com/resource/clover-web-200x200-or8.png';
var desc = '全新爆爽消消乐来袭，和我一起闯关吧！不用下载就能玩';
var title = '海滨消消乐';
const SnsMini = require("./SnsMini")

let sns = xClass("snsWechatgame", SnsMini)

var RewardAdDefaultId = [
    "8g55a7dj5ahd4tv39g",
    "5079g3if1829adbd3i",
    "4krbu8spbtj7kpge0c",
    "bc0j9h239gb75ie2ib",
    "37y0okpulp046mfm0b",
    "5c85815f21fc4oun6n",
    "1i01528ehj2hii5b8b",
    "25drmkln14d1i53hf0",
    "19kkfn76ph35cen563",
    "8cd1jm5alac4jja2g8",
    "64dj1ib21enbkgdfk9",
    "fsoqpe4pek11df8jua",
    "3au293ajfi95b5av37",
    "2bdi44d3eoi28j814g"
]
var RewardAdId = {
    "FailAdd1Step":"8g55a7dj5ahd4tv39g",
    "FailAdd2Step":"5079g3if1829adbd3i",
    "MarkExtraReward":"4krbu8spbtj7kpge0c",
    "Remark":"bc0j9h239gb75ie2ib",
    "MarketGetCash":"37y0okpulp046mfm0b",
    "CashNotEnough":"5c85815f21fc4oun6n",
    "CoinNotEnough":"1i01528ehj2hii5b8b",
    "TopGetCoin":"25drmkln14d1i53hf0",
    "GoldMatchAddStep":"19kkfn76ph35cen563",
    "CoinMatchAddStep":"8cd1jm5alac4jja2g8",
    "CoinMatchFailAddStep":"64dj1ib21enbkgdfk9",
    "CoinMatchReset" :"64dj1ib21enbkgdfk9",
    "LimitBlockColloctionAddTime":"fsoqpe4pek11df8jua",
    "Startegy":"3au293ajfi95b5av37",
    "PassLevelDoubleReward":"2bdi44d3eoi28j814g",
    "SeasideStarDoubleCollect":"2bdi44d3eoi28j814g",

}

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'wx_video_ad';
    this.rewardAdDefaultIdx = -1;

    /**
     * 2020/06/17 by xiaolu.hu[验证版本号：Android 11.5.0]: 抖音端外分享有回调，但是测试时出现偶发情况，分享出去的内容没有图也没有文字，呈现黑色，并且游戏展示出未收到回调逻辑。因此还是使用分享时间进行兜底
     * 
     * 2020/06/28 by xiaolu.hu[验证版本号：Android 11.5.0]: 补充必现无回调情况：游客登陆进行分享->提示登陆->取消登陆
     */
    this.ttShareTimer =0;// -1; // 抖音端外分享可能没有回调，到时间了自动返回
//    this.ttShareTimerId = null; // 端外分享定时

    this.ttCanShare = false;

    this.allowAnonymouseLogin = true;  // 是否允许游客登陆
}

sns.prototype.addShortcut = function (onSuccess, onFail) {
    window.mini.addShortcut({
        success(){
            onSuccess()
        },
        fail(res){
            onFail(res.errMsg)
        }
    })
}
sns.prototype._packShareParam = function () {
    let param = {
        onShare: ()=> {
            let textConfig = TextsManager.getInstance().getRandomTexts('default')
            // let imageInfo = this.decodeSafeLink(textConfig.bg)
            let shareInfo = {
                // title: textConfig.content,
                // imageUrl: imageInfo.imageUrl,
                // imageUrlId: imageInfo.imageUrlId,
                query: this.getShareLinkStr({
                    textId: textConfig.textId
                })
            }
            return shareInfo
        }
    }
    return param;
}
/**
 * 转译广告位
 * @param adPos 广告id的名字
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    if (RewardAdId[adPos] && useDefaultId == false){
        return RewardAdId[adPos];
    }else{
        if (this.rewardAdDefaultIdx == -1){
            return RewardAdDefaultId[0];
        }
        return RewardAdDefaultId[this.rewardAdDefaultIdx];
    }
}

sns.prototype.hasMoreRewardAdId = function(){
    if((this.rewardAdDefaultIdx+1) < RewardAdDefaultId.length){
        return true;
    }else{
        return false;
    }
}

sns.prototype.setNextRewardAdId = function(){
    this.rewardAdDefaultIdx += 1;
    console.log("setNextRewardAdId", this.rewardAdDefaultIdx)
}

/**
 * code换取session信息
 * @param {*} code 匿名code/登录用户code
 * @param {*} isAnonymous 用户是否为匿名状态（非端登录）
 * @param {(err, {snsuid, token})=> void} callback 
 */
function _code2session(code, isAnonymous, callback) {
    let data = {
        op: "session_key",
        pf: MiniPlatform.tt
    }
    if (isAnonymous) {
        data.anonymous_code = code;
    } else {
        data.code = code
    }

    let onSuccess = evt=> {
        callback && callback(null, evt.data)
    }
    
    let onFail = evt=> {
        cc.error("tt.code2session failed", evt);
        let errorTxt = "tt.code2session failed"
        if (evt.data == SERVER_GLOBAL_CODE.SERVER_CLOSED_LOGIN){
            errorTxt = "server_close"
        }
        let uid = ""
        if (evt.data.desc) uid = evt.data.desc.split(":")[1]
        if (evt.data.code == SERVER_GLOBAL_CODE.SERVER_BLACK_LIST){
            errorTxt = {
                key: "server_black_list",
                desc: `当前账号（${uid}）处于封禁状态，如有疑问请联系客服。`
            }
        }
        callback && callback(errorTxt,  null);
    }
    let http = H5LoginHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(data);
}

function _sendLog(log) {
    let systemInfo = mini.getSystemInfoSync()
    log += " sdkVersion: " + systemInfo.SDKVersion + ", wxVersion: " + systemInfo.version + ", systemInfo: " + JSON.stringify(systemInfo)
    if (window.logCenter) {
        let msg = {
            message: "login fail: " + log
        }
        window.logCenter.log(msg)
    } else {
        cc.error("login fail: " + log)
    }
}

/**
 * 匿名玩家登录
 * @param {*} anonymous_openid 
 * @param {*} cb 
 */
function _anonymousLogin(anonymous_openid, cb) {
    console.log("debug]_anonymousLogin", anonymous_openid)
    let info = {
        op: "login",
        snsuid: anonymous_openid,
        anonymous_openid: anonymous_openid,
        avatarUrl: "https://ff.happyelements.com/xclover/clover-web@100.png"
    }
    cb(info);
}

/**
 * 端登录未授权玩家登录
 * @param {*} cb 
 */
function _noscopeLogin(openid, anonymous_openid, cb, session_key) {
    console.log("debug]_noscopeLogin", anonymous_openid,openid)
    let info = {
        op: "login",
        snsuid: openid,
        h5game_openid: openid,
      //  anonymous_openid_old: anonymous_openid,
        avatarUrl: "https://ff.happyelements.com/xclover/clover-web@100.png",
        session_key: session_key
    }
    if (anonymous_openid)
        info.anonymous_openid_old = anonymous_openid;
    cb(info);
}


/**
 * 端登录已授权玩家登录
 * @param {*} code 
 * @param {*} anonymous_openid 
 * @param {*} userInfo 
 * @param {*} cb 
 */
function _normalLogin(openid, anonymous_openid, userInfo, cb) {
    console.log("debug]_normalLogin", anonymous_openid,openid)
    userInfo.snsuid = openid;
    userInfo.h5game_openid = openid;
    if (anonymous_openid)
        userInfo.anonymous_openid_old = anonymous_openid;
    cb(userInfo);
}

/**
 * 展示登录失败弹窗
 * @param {*} reason 
 * @param {*} log 
 * @param {*} cb 
 */
function _showLoginFailModal(reason, log, cb) {
    reason = reason || "登录失败了哦，请重试~"
    _sendLog(log)
    mini.showModal({
        title: reason,
        showCancel: false,
        success: ()=> cb({ failRetry: 1 })
    })
}

/**
 * tt.login成功后处理
 * @param {*} loginRes 
 * @param {*} cb 
 */
function _onTTLoginSuccess(loginRes, cb){
    let { code, anonymous_openid } = loginRes; 

    // 没有code代表用户非端登录状态
    if (!code) {
        _anonymousLogin(anonymous_openid, cb);
        return;
    }

    // 从服务器获取用户openid
    _code2session(code, false, (err, data)=> {
        if (err) {
            let reason = ""
            if (err == "server_close"){
                reason = "服务器维护中"
            }
            if (err.key == "server_black_list"){
                reason = err.desc || "" 
            }
            _showLoginFailModal(reason, "_code2session failed." + JSON.stringify({
                code,
                anonymous_openid
            }),cb);

        } else {
            console.log("[####]tt _code2session data",data)
            let { snsuid } = data;
            let session_key = ""
            if (data){
                session_key = data.token || ""
            }
            //判断是否授权
            mini.getSetting({
                success: res=> {
                    cc.log(["####getSetting: "], res.authSetting, res.authSetting["scope.userInfo"]);
                    if (res.authSetting  && res.authSetting["scope.userInfo"]) {
                        console.log("[####]get user info directly")
                        mini.getUserInfo({
                            withCredentials: true,
                            success:function(data){
                                cc.log("[####]getUserInfo success", data, code, snsuid)
                                cc.log("[####]getUserInfo success snsuid", snsuid)
                                var rawData = {};
                                if (data.rawData){
                                    rawData = JSON.parse(data.rawData);
                                }
                                var info = {
                                    rawData:data.rawData,
                                    signature:data.signature,
                                    encryptedData:data.encryptedData,
                                    iv:data.iv,
                                    avatarUrl:rawData.avatarUrl,
                                    nickName:rawData.nickName,
                                    session_key:session_key
                                }
                                _normalLogin(snsuid, anonymous_openid, info, cb)
                            },
                            fail:function(){
                                console.log("[####]get user info failed");
                                _noscopeLogin(snsuid, anonymous_openid, cb, session_key);
                            }
                        });
                    } else {                
                        _noscopeLogin(snsuid, anonymous_openid, cb, session_key);
                    }
                }
            });
        }
    });    
}

sns.prototype.getOpenKey = function (cb) {
    let self = this

    // ！！！抖音不同用户之间缓存不隔离！！！ openid不使用本地缓存
    let anonymousOpenId = cc.UserDefault.getInstance().getStringForKey("anonymous_openid", "");
    let forceAppLogin = self.allowAnonymouseLogin? false: true;
    let defaultErrMsg = self.allowAnonymouseLogin? "": "请登录抖音账号再开始游戏哦~";
    mini.login({
        force: forceAppLogin,
        success: res=> {
            if (!res.anonymousCode) {
                console.log("[####]tt login success but return data is not correct", res.code, res.anonymousCode);
                _showLoginFailModal(defaultErrMsg, "mini.login success without anonymousCode. " + JSON.stringify({
                    code: res.code,
                    anonymousCode: res.anonymousCode
                }), cb);
            } else if (!res.code && !self.allowAnonymouseLogin) {
                // 不允许游客登陆的情况下没有code，返回错误
                let errInfo = JSON.stringify({
                    code: res.code,
                    anonymousCode: res.anonymousCode,
                    allowAnonymouseLogin: self.allowAnonymouseLogin
                })
                console.log("[####]tt login success but return data is not correct", errInfo);
                _showLoginFailModal(defaultErrMsg, "mini.login success without code. " + errInfo, cb);
            }else {
                console.log("[####]tt login success", res);

                // 不开游客登陆时不处理anonymousOpenId
                if (!self.allowAnonymouseLogin) {
                    _onTTLoginSuccess({
                        code: res.code,
                        isLogin: res.isLogin
                    }, cb)
                } else if (!anonymousOpenId) {
                    // 如果没有匿名openid需要从服务器获取一次
                    _code2session(res.anonymousCode, true, (err, data)=> {
                        if (err) {
                            let reason = defaultErrMsg
                            if (err == "server_close"){
                                reason = "服务器维护中"
                            }
                            if (err.key == "server_black_list"){
                                reason = err.desc || "" 
                            }
                            _showLoginFailModal(reason, "mini.login get anonymous_openid failed. " + JSON.stringify({
                                code: res.code,
                                anonymousCode: res.anonymousCode
                            }), cb);
                        } else {
                            let { snsuid } = data;
                            cc.UserDefault.getInstance().setStringForKey("anonymous_openid", snsuid);

                            _onTTLoginSuccess({
                                anonymous_openid: snsuid,
                                code: res.code,
                                isLogin: res.isLogin
                            }, cb)
                        }
                    });
                } else {
                    _onTTLoginSuccess({
                        anonymous_openid: anonymousOpenId,
                        code: res.code,
                        isLogin: res.isLogin
                    }, cb)
                }
            }
        },
        complete:function(){
            console.log("[####]tt login complete");
        },
        fail:function(res){
            console.log("[####]tt login failed", res.errMsg);            
            _showLoginFailModal(defaultErrMsg, "mini.login failed." + JSON.stringify(res), cb);
        }
    });
}


sns.prototype.checkAuthorizeWithUserBtn =  function (agreeCb, denyCb){
    var self = this

    console.log("!!!!wx check autiorize with user btn")
   
    function showAuthorizeModal(agreeCb, denyCb) {
        mini.showModal({
            title: '用户未授权',
            content: '为正常使用程序功能，请按点击确定并在授权管理中选中允许访问用户信息',
            showCancel: false,
            success: function (res) {
                if (res.confirm) {
                    tt.authorize({
                        scope: "scope.userInfo",
                        success() {
                            if (agreeCb){
                                agreeCb()
                            }
                        },
                        fail() {
                            if (denyCb){
                                denyCb()
                            }
                        },
                        complete() {
                          
                        }
                    });
                }
            }
        })
    }

    let needCreateUserInfoBtn = false
    mini.getSetting(
        {
            success:function(res){
                if (res.authSetting != null && !res.authSetting["scope.userInfo"]){
                    needCreateUserInfoBtn = true
                }
                if (needCreateUserInfoBtn && !self.userInfoBtn){
                    showAuthorizeModal(agreeCb, denyCb);
                }else{
                    if (agreeCb){
                        agreeCb()
                    }
                }

            },
            fail:function(){
                console.warn("get setting failed")
                if (agreeCb){
                    agreeCb()
                }
            }
        }
    )
}


sns.prototype.onLoginFinish = function(openid, sessionid){
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
        console.log("[####]login finish tt openid sessionid",openid,sessionid)
    }else{
        console.log("[####]login finish failed no openid or sessionid")
    }
}

sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}

sns.prototype.decodeSafeLink = function (url) {
    // let imageUrlId = null
    // let imageUrl = url
    // if (url.startsWith("sflink:")) {
    //     let info = url.replace("sflink:", "").split("||")
    //     imageUrlId = info[0]
    //     imageUrl = info[1]
    // }
    // return { 
    //     imageUrl:imageUrl,
    //     imageUrlId:imageUrlId,
    // }
    return { 
            imageUrl:url,
            imageUrlId:"",
        }
}

/**
 * 是否允许使用分享，抖音当前版本11.3分享点击的启动参数无法获取，之后抖音更新后会修复
 * 现在用抖音版本号来判断是否可以分享
 * 
 * 已在Android-11.5.0修复 by xiaolu.hu@2020-06-16
 */
sns.prototype.curVerCanShare = function() {
    return this.ttCanShare;
}

sns.prototype.refreshcurVerCanShare = function() {
    CfgManager.load("wx_group_share").then(()=>{
        var cfgData = CfgManager.get("wx_group_share");
        var ttShareSDKVer = cfgData.douyin_share_open_android_version || "11.5.0";
        CfgManager.release("wx_group_share");

        this.ttCanShare = mini.compareVersion(mini.getSystemInfoSync().version, ttShareSDKVer) >= 0
        console.log("###########refreshcurVerCanShare############", this.ttCanShare)
    });
}

sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    console.log("#### share")
    let self = this
    if (!this.ttShareTimer){
        CfgManager.load("game")
        .then((data) => {
            var config = data.get("game");
            this.ttShareTimer = config.douyin_share_timer || 5000;
            console.log("ttShareTimer", this.ttShareTimer)
            CfgManager.release("game");
            this.share(textId, platform, title, imageUrl, _link, callback);
        });
        return
    }
    if (platform == XcloverPlatform.wechatgame && mini.shareAppMessage) {
        imageUrl = imageUrl ? imageUrl : shortCutImg
        let imageInfo = self.decodeSafeLink(imageUrl)
        title = title ? title : "海滨消消乐"
        //分享链接加上textId
        if (textId && _link) {
            _link = _link + '&textId=' + textId;
        }
        var hasCallback = false;
        console.log("#### ttShareTimer", this.ttShareTimer)
        setTimeout(()=>{
            console.log("#### share timeout")
            if (!hasCallback){
                callback({
                    retCode: 0,
                    data: {
                        retCode: 2,
                        msg: "分享成功！"
                    }
                });
            }
        }, this.ttShareTimer);
        // 抖音分享能判断成功
        let share = {
            shareInfo: {
                templateId:title,
                query: _link,
                success() {
                    console.log("#### success")
                    if (!hasCallback){
                        hasCallback = true;
                        callback({
                            retCode: 0,
                            data: {
                                retCode: 2,
                                msg: "分享成功！"
                            }
                        });
                    }
                },
                fail(){
                    console.log("#### fail")
                    if (!hasCallback){
                        hasCallback = true;
                        callback({
                            retCode: 1,
                            data: {
                                retCode: 2,
                                msg: "分享未发送"
                            }
                        });
                    }
                },
                complete(){
                    console.log("#### complete")
                    if (!hasCallback){
                        callback({
                            retCode: 1,
                            data: {
                                retCode: 2,
                                msg: "分享未发送"
                            }
                        });
                    }
                }
            }
        }
        console.log("share.shareInfo", share.shareInfo)
        mini.shareAppMessage(share.shareInfo)
    } else {
        callback({
            retCode: 2,
            data: {
                retCode: 2,
                msg: "分享未发送！"
            }
        })
    }
}

sns.prototype.popBack = function () {
    window.mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

/**
 * 
 * @param {*} img      背景 Image path
 * @param {*} info 
 *                     {
 *                         avatar: avatar path
 *                         avatar2: avatar2 path
 *                         nickname: nickname
 *                         sytle: font 的 css 样式, eg: '48px serif'
 *                         avatarPos: {x:100, y:100}
 *                         nicknamePos: {x:100, y:100}
 *                         radius: 头像半径
 *                     }
 * @param {*} callback 
 */
sns.prototype.drawDataToImg = function (bgpath, info, callback) {

    let oldCallback = callback
    let called = false
    callback = function (path) {
        if (!called) {
            oldCallback && oldCallback(path)
            called = true
        }
    }

    // 如果没有参数直接返回
    if (!info) {
        setTimeout(() => {
            callback && callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
        }, 0);
        return
    }

    let safeImgMap = {}
    let drawImage = function() {
        let time = 1
        let avatarImg = null
        let avatarImgFail = null
        let radius = info.radius || 100 / 2
        if (info.avatar) {
            time ++
            avatarImg = mini.createImage()
        }
        if (info.avatarFail) {
            time ++
            avatarImgFail = mini.createImage()
        }
        let mycanvas = mini.createCanvas()
        let context = mycanvas.getContext("2d")
        let loadCallback = timeLimitCallbackFunc(onLoadingComplete, time)
        let img = mini.createImage()

        let fillStyle = info.fillSytle || "white"

        function onLoadingComplete() {

            mycanvas.width = img.width
            mycanvas.height = img.height

            // 背景
            context.drawImage(img, 0, 0)

            // 头像
            if (info.avatar) {
                context.beginPath()
                context.arc(info.avatarPos.x + radius, info.avatarPos.y + radius, radius, 0, 2 * Math.PI)
                context.closePath()
                context.save()
                context.clip()
                context.drawImage(avatarImg, info.avatarPos.x, info.avatarPos.y, radius * 2, radius * 2) // 头像
                context.restore()
            }

            // 失败者头像
            if (info.avatarFail) {
                context.beginPath()
                let failRadius = info.avatarFailRaidus || radius
                context.arc(info.avatarFailPos.x + failRadius, info.avatarFailPos.y + failRadius, failRadius, 0, 2 * Math.PI)
                context.closePath()
                context.save()
                context.clip()
                context.drawImage(avatarImgFail, info.avatarFailPos.x, info.avatarFailPos.y, failRadius * 2, failRadius * 2) // 头像
                context.restore()
            }

            // 名字
            if (info.nickname) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.style
                context.fillText(info.nickname, info.nicknamePos.x, info.nicknamePos.y)
                context.restore()
            }

            // levelDesc
            if (info.levelDesc) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.levelStyle
                let width = context.measureText(info.levelDesc).width
                context.fillText(info.levelDesc, (img.width - width) / 2, info.levelDescPos.y)
                context.restore()
            }

            // score
            if (info.score) {
                context.save()
                context.fillStyle = fillStyle
                context.font = info.scoreStyle
                let width = context.measureText(info.score).width
                context.fillText(info.score, (img.width - width) / 2, info.scorePos.y)
                context.restore()
            }

            try {
                let tempFilePath = null
                tempFilePath = mycanvas.toTempFilePathSync({
                    x: 0,
                    y: 0,
                    width: img.width,
                    height: img.height,
                    destWidth: img.width,
                    destHeight: img.height
                })
                callback(tempFilePath)
                if (img) {
                    img.src = ""
                    img = null
                }
                if (avatarImg) {
                    avatarImg.src = ""
                    avatarImg = null
                }
                if (avatarImgFail) {
                    avatarImgFail.src = ""
                    avatarImgFail = null
                }
                mycanvas  = null
                context   = null
            } catch (error) {
                callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
                console.error(error)
            }
        }

        let errorCallback = ()=> {
            callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
        }
        img.src = safeImgMap[cc.loader.getUrl(cc.loader.resPath, bgpath)]
        img.onload = loadCallback
        img.onerror = errorCallback
        if (avatarImg) {
            avatarImg.src = safeImgMap[info.avatar]
            avatarImg.onload = loadCallback
            avatarImg.onerror = errorCallback
        }
        if (avatarImgFail) {
            avatarImgFail.src = safeImgMap[info.avatarFail]
            avatarImgFail.onload = loadCallback
            avatarImgFail.onerror = errorCallback
        }
    }
    
    let imgList = [cc.loader.getUrl(cc.loader.resPath, bgpath)];
    if (info.avatar) imgList.push(info.avatar);
    if (info.avatarFail) imgList.push(info.avatarFail);

    if (mini.useStrictImgMode()) {
        imgList.forEach(v=> {
            mini.downloadFile({
                url: v,
                success: res => {
                    safeImgMap[v] = (res.statusCode === 200? res.tempFilePath: "") || ""
                    if (Object.keys(safeImgMap).length === imgList.length) 
                        drawImage();
                },
                fail: err=> {
                    safeImgMap[v] = '';
                    if (Object.keys(safeImgMap).length === imgList.length) 
                        drawImage();
                },
                extractmap: {
                    picurl: v,
                    node: 'sns.drawDataToImg',
                }
            })
        });
        
    } else {
        imgList.forEach(v=> safeImgMap[v] = v);
        drawImage();
    }
    // setTimeout(() => {
    //     callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
    // }, 10*1000);
}


/**
 * 是否允许开启Pvp
 */
sns.prototype.allowPvp = function() {
    return true;
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}



/**
 * 抖音获取不到省份
 */
sns.prototype.fetchProvince = function(callback, lang = "zh_CN") {
    mini.getUserInfo({
        withCredentials: false,
        success: res=> {
            console.log("[SnsProxy]", "fetchProvince. mini.getUserInfo success.", res)
            let userInfo = res && res.userInfo;
            if (userInfo) {
                let { province, language, country } = userInfo;
                callback && callback(null, {
                    country,
                    province,
                    lang: language
                })
            } else {
                callback && callback(null, {
                    country: "",
                    province: "",
                    lang: lang
                })
            }
        },
        fail: res=> {
            callback && callback(res, null); 
        }
    });
}

var recorderStatus = 0 // 0未开始，1录屏中，2暂停，3结束中
/**
 * 抖音的录屏
 */
sns.prototype.startRecorder = function(duration = 10){
    if (recorderStatus != 0){
        return -1;
    }
    var recorder = mini.getGameRecorderManager();
    recorder.start();
    recorderStatus = 1;
}

sns.prototype.stopRecorder = function(){
    return new Promise((resolve, reject) => {
        if (recorderStatus == 0){
            reject();
        }
        var recorder = mini.getGameRecorderManager();
        recorder.onStop(res => {
            resolve(res.videoPath);
            recorderStatus = 0;
        })
        recorder.stop();
        recorderStatus = 3;
    })
}

sns.prototype.pauseRecorder = function(){
    if (recorderStatus != 1){
        return -1;
    }
    var recorder = mini.getGameRecorderManager();
    recorder.pause();
    recorderStatus = 2;
}

sns.prototype.resumeRecorder = function(){
    if (recorderStatus != 1){
        return -1;
    }
    var recorder = mini.getGameRecorderManager();
    recorder.pause();
    recorderStatus = 2;
}

sns.prototype.showAddMineView = function(content, success, fail){
    mini.showFavoriteGuide({
        content: content || "一键添加到我的小程序",
        success(res) {
            console.log("引导组件展示成功");
            success && success();
        },
        fail(res) {
            console.log("引导组件展示失败");
            fail && fail();
        }
    })
}
/**
 * 是否禁止只要触发分享（不判断任何回调信息）就算成功
 */
sns.prototype.forbidShareSuccessDirectly = function() {
    return true;
}


/**
 * 检查用户是否发生了变更
 * 抖音不同账号之间缓存不隔离，登陆用户发生变动时需要删除缓存
 */
sns.prototype.checkIsUserChange = function(uid) {
    let oldUid = cc.UserDefault.getInstance().getStringForKey("h5game_uid", "");
    if (oldUid != uid) {
        cc.UserDefault.getInstance().clear();
        cc.UserDefault.getInstance().setStringForKey("h5game_uid", uid);
    }
}

/**
 * 版本号比较
 * @return 
 *  1: v1 > v2
 *  0: v1 = v2
 *  -1: v1 < v2
 */
function compareVersion(v1, v2) {
    let ary1 = v1.split('.')
    let ary2 = v2.split('.')
    const len = Math.max(ary1.length, ary2.length)
  
    while (ary1.length < len) {
        ary1.push('0')
    }
    while (ary2.length < len) {
        ary2.push('0')
    }
  
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(ary1[i])
      const num2 = parseInt(ary2[i])
  
      if (num1 > num2) {
        return 1
      } else if (num1 < num2) {
        return -1
      }
    }
  
    return 0
}

/**
 * 校验版本号
 */
function vaildVersion(version, minVersion) {
    return compareVersion(version, minVersion) >= 0
}

module.exports = sns